import type { BulkFieldValue } from '../../../types'

export function computeNotes(
  orders: uui.domain.client.rm.ExtendedOrderStep[],
): BulkFieldValue<string> {
  const notes = orders[0].orderStep.notes
  const exact = orders.every(o => o.orderStep.notes === notes)

  if (exact) {
    return {
      status: 'exact',
      value: notes,
    }
  }

  return {
    status: 'mixed',
  }
}
